module.exports = __webpack_public_path__ + "media/images/diy/wedding_lighting_that_shows_names-b59173c21cf3a91b9868423918c76da1.png";